import React, { useEffect, useState } from 'react';

import { LoadingSpinner } from '../ui/LoadingSpinner';

export const WhitelabelProvider = ({ children, whitelabelLoading }) => {
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    if (!whitelabelLoading && !hasLoaded) {
      setHasLoaded(true);
    }
  }, [whitelabelLoading, hasLoaded]);

  // Show loading spinner while whitelabel data is being fetched
  if (whitelabelLoading || !hasLoaded) {
    return <LoadingSpinner />;
  }

  return children;
};